import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Lock, CheckCircle, AlertCircle } from 'lucide-react';
import api from '../services/api';
import '../styles/Login.css';

function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) return setError('A senha deve ter ao menos 6 caracteres');
    if (password !== confirm) return setError('As senhas não conferem');

    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao redefinir senha.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-error" style={{margin:0}}>
            <AlertCircle size={20}/> Link inválido. Solicite um novo na página de recuperação.
          </div>
          <Link to="/forgot-password" className="login-link" style={{marginTop:20}}>Recuperar senha</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo">
            <img src="/logo.png" alt="BDA" style={{width:90,height:90,objectFit:'contain'}} />
          </div>
          <h1>Nova senha</h1>
          <p>Defina uma senha nova para sua conta</p>
        </div>

        {done ? (
          <div className="login-success">
            <CheckCircle size={36} color="#16A34A"/>
            <h3>Senha redefinida!</h3>
            <p>Redirecionando para o login...</p>
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label htmlFor="rp-password">Nova senha</label>
              <div className="login-input-wrap">
                <Lock size={16}/>
                <input id="rp-password" className="login-input" type="password"
                  value={password} onChange={e => setPassword(e.target.value)}
                  required minLength={6} autoFocus />
              </div>
            </div>
            <div className="login-field">
              <label htmlFor="rp-confirm">Confirmar nova senha</label>
              <div className="login-input-wrap">
                <Lock size={16}/>
                <input id="rp-confirm" className="login-input" type="password"
                  value={confirm} onChange={e => setConfirm(e.target.value)}
                  required minLength={6} />
              </div>
            </div>

            {error && <div className="login-error"><AlertCircle size={15}/> {error}</div>}

            <button type="submit" className="login-submit" disabled={loading}>
              {loading ? 'Salvando...' : 'Redefinir senha'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
